<sb-dashboard-widget
  [isLoading]="isLoading()"
  [isEmpty]="openShifts().length === 0"
  [title]="'My open shifts' | translate"
  [emptySettings]="{
    description: 'No open shifts - new ones will show up here.' | translate,
    icon: 'calendar-time-add-cute-re',
  }"
>
  <!-- TODO check e2e, this probably isn't targeting the input itself now -->
  <sb-dashboard-widget-select
    id="show-period"
    [options]="periodOptions"
    [model]="widgetPeriod()"
    (modelChange)="onPeriodChange($event)"
    [label]="'Next' | translate"
  />
  <table class="table-widget table-uniform-rows">
    <thead>
      <tr>
        <th class="row-20">{{ 'Date' | translate }}</th>
        <th class="row-20">{{ 'Time' | translate }}</th>
        <th class="row-20">{{ 'Location' | translate }}</th>
        <th class="row-20">{{ 'Team' | translate }}</th>
        <th class="row-20">{{ 'Department' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (openShift of openShifts(); track openShift.occurrence_id) {
        <tr
          class="cursor-pointer"
          role="link"
          [routerLink]="['', { outlets: { modal: ['schedule-open-shift', openShift.occurrence_id] } }]"
        >
          <td>{{ openShift.date | localeDate: 'medium' }}</td>
          <td>
            <span>{{ openShift.starttime | time }}</span>
            @if (!openShift.hide_end_time) {
              <span> - {{ openShift.endtime | time }}</span>
            }
          </td>
          <td>{{ openShift.location_name }}</td>
          <td>{{ openShift.Team?.name }}</td>
          <td>{{ openShift.department_name }}</td>
        </tr>
      }
    </tbody>
  </table>
</sb-dashboard-widget>
